// Multi-language dictionaries. Add more languages by adding a new export.
// Keys must match across languages; Telugu is the authoritative base.

export const te = {
  home: "హోమ్", liveTv: "లైవ్ టీవీ", admin: "అడ్మిన్",
  search: "వెతకండి", searchPlaceholder: "వార్తలు వెతకండి...",
  flashNews: "బ్రేకింగ్ న్యూస్", breakingNews: "బ్రేకింగ్ న్యూస్",
  siteTagline: "నమ్మకమైన తెలుగు వార్తలు · 24×7",
  privacy: "గోప్యతా విధానం", terms: "నిబంధనలు",
  latestNews: "తాజా వార్తలు", trendingNow: "ట్రెండింగ్ ఇప్పుడు",
  onAir: "ప్రసారంలో", viewAll: "అన్నీ చూడండి →",
  abnVideos: "న్యూస్ 9 వీడియోలు",
  weather: "వాతావరణం", stockMarket: "స్టాక్ మార్కెట్",
  relatedStories: "సంబంధిత వార్తలు", share: "షేర్",
  articleNotFound: "వార్త దొరకలేదు", backToHome: "← హోమ్‌కి తిరిగి వెళ్ళండి",
  views: "వ్యూస్",
  category: "విభాగం", stories: "వార్తలు",
  noStoriesYet: "ఈ విభాగంలో వార్తలు లేవు.", checkBackSoon: "త్వరలో మళ్ళీ చూడండి.",
  previous: "మునుపటి", next: "తర్వాత", page: "పేజీ", of: "లో",
  searchResults: "శోధన ఫలితాలు", noResults: "ఫలితాలు దొరకలేదు", resultsFor: "కోసం ఫలితాలు",
  adminPortal: "అడ్మిన్ పోర్టల్", signInToPublish: "వార్తలు ప్రచురించడానికి సైన్ ఇన్ చేయండి",
  email: "ఇమెయిల్", password: "పాస్‌వర్డ్", signIn: "సైన్ ఇన్", signingIn: "సైన్ ఇన్ అవుతోంది…",
  newsroomDashboard: "న్యూస్ రూమ్ డాష్‌బోర్డ్", newArticle: "కొత్త వార్త",
  logout: "లాగ్ అవుట్", signedInAs: "సైన్ ఇన్ అయినవారు",
  articles: "వార్తలు", categories: "విభాగాలు", siteSettings: "సైట్ సెట్టింగ్‌లు",
  ads: "ప్రకటనలు", pages: "పేజీలు", youtubeSync: "యూట్యూబ్ సింక్",
  contactSettings: "కాంటాక్ట్ వివరాలు", title: "శీర్షిక", date: "తేదీ",
  status: "స్థితి", actions: "చర్యలు", live: "లైవ్", draft: "డ్రాఫ్ట్",
  loading: "లోడ్ అవుతోంది…", noArticlesYet: "ఇంకా వార్తలు లేవు. కొత్త వార్త క్లిక్ చేయండి.",
  editArticle: "వార్త సవరించండి", createArticle: "కొత్త వార్త",
  titleRequired: "శీర్షిక *", summary: "సారాంశం", categoryRequired: "విభాగం *",
  tags: "ట్యాగ్‌లు (కామాతో వేరు చేయండి)", body: "వార్త వివరాలు * (తెలుగు అనుమతి)",
  bodyFont: "తెలుగు ఫాంట్", coverImage: "కవర్ చిత్రం",
  additionalImages: "అదనపు చిత్రాలు (ఫోటో గ్యాలరీ)",
  pasteUrlOrUpload: "URL పేస్ట్ చేయండి లేదా అప్‌లోడ్ చేయండి…",
  upload: "అప్‌లోడ్", uploading: "అప్‌లోడ్ అవుతోంది…",
  addImage: "చిత్రం జోడించండి", remove: "తీసివేయండి",
  youtubeEmbedUrl: "యూట్యూబ్ ఎంబెడ్ URL",
  featured: "ఫీచర్డ్ (హీరో)", flashNewsToggle: "బ్రేకింగ్ న్యూస్‌లో చూపించు",
  published: "ప్రచురించబడింది", update: "అప్‌డేట్", publish: "ప్రచురించు",
  cancel: "రద్దు చేయి", confirmDelete: "ఈ వార్తను తొలగించాలా?",
  addCategory: "విభాగం జోడించండి", slug: "స్లగ్ (URL)",
  nameEnglish: "పేరు (ఇంగ్లీష్)", nameTelugu: "పేరు (తెలుగు)",
  order: "క్రమం", save: "సేవ్", edit: "సవరించు", delete: "తొలగించు",
  liveTvSettings: "లైవ్ టీవీ సెట్టింగ్‌లు",
  streamUrl: "స్ట్రీమ్ URL", streamType: "స్ట్రీమ్ రకం",
  streamTypeYoutube: "యూట్యూబ్", streamTypeHls: "HLS (.m3u8)", streamTypeMp4: "MP4",
  channelTitleEn: "చానెల్ పేరు (ఇంగ్లీష్)", channelTitleTe: "చానెల్ పేరు (తెలుగు)",
  saveSettings: "సెట్టింగ్‌లు సేవ్ చేయండి",
  liveTvHelp: "యూట్యూబ్: /embed/VIDEO_ID URL. HLS: .m3u8. RTMP నేరుగా వెబ్‌లో పని చేయదు.",
  latestNewsFeed: "తాజా వార్తల ఫీడ్",
  channelId: "యూట్యూబ్ చానెల్ ID", channelIdHelp: "మీ చానెల్ URL నుంచి channel ID కాపీ చేయండి (UC...తో మొదలవుతుంది)",
  autoImport: "ఆటో ఇంపోర్ట్", defaultCategory: "డిఫాల్ట్ విభాగం",
  syncNow: "ఇప్పుడే సింక్ చేయండి", syncing: "సింక్ అవుతోంది...",
  addAd: "ప్రకటన జోడించండి", adName: "ప్రకటన పేరు", placement: "స్థానం",
  linkUrl: "క్లిక్ లింక్ URL", imageUrl: "చిత్రం URL", videoUrl: "వీడియో URL", active: "యాక్టివ్",
  privacyPolicy: "గోప్యతా విధానం", termsConditions: "నిబంధనలు మరియు షరతులు",
  phone: "ఫోన్", address: "చిరునామా",
  footerTagline: "నమ్మకమైన తెలుగు వార్తలు. బ్రేకింగ్ న్యూస్, లోతైన విశ్లేషణ, ముఖ్యమైన కథనాలు.",
  sections: "విభాగాలు", more: "మరిన్ని",
  newsletter: "వార్తాలేఖ", newsletterDesc: "రోజువారీ ముఖ్య వార్తలు మీ ఇమెయిల్‌కి.",
  yourEmail: "మీ ఇమెయిల్", subscribe: "సబ్‌స్క్రయిబ్",
  allRightsReserved: "© 2026 న్యూస్ 9 టుడే. అన్ని హక్కులు రిజర్వ్ చేయబడ్డాయి.",
  editorialTrusted: "సంపాదకీయ · స్వతంత్ర · నమ్మకమైన",
  contactUs: "సంప్రదింపులు",
  language: "భాష", fontSize: "ఫాంట్ సైజ్", channels: "చానెల్‌లు",
};

export const en = {
  home: "Home", liveTv: "Live TV", admin: "Admin",
  search: "Search", searchPlaceholder: "Search news...",
  flashNews: "Breaking News", breakingNews: "Breaking News",
  siteTagline: "Trusted News · 24×7", privacy: "Privacy Policy", terms: "Terms",
  latestNews: "Latest News", trendingNow: "Trending Now",
  onAir: "On Air", viewAll: "View all →", abnVideos: "News 9 Videos",
  weather: "Weather", stockMarket: "Stock Market",
  relatedStories: "Related Stories", share: "Share",
  articleNotFound: "Article not found", backToHome: "← Back to Home",
  views: "views",
  category: "Category", stories: "stories",
  noStoriesYet: "No stories yet in this section.", checkBackSoon: "Check back soon.",
  previous: "Previous", next: "Next", page: "Page", of: "of",
  searchResults: "Search Results", noResults: "No results found", resultsFor: "Results for",
  adminPortal: "Admin Portal", signInToPublish: "Sign in to publish news",
  email: "Email", password: "Password", signIn: "Sign In", signingIn: "Signing in…",
  newsroomDashboard: "Newsroom Dashboard", newArticle: "New Article",
  logout: "Logout", signedInAs: "Signed in as",
  articles: "Articles", categories: "Categories", siteSettings: "Site Settings",
  ads: "Ads", pages: "Pages", youtubeSync: "YouTube Sync",
  contactSettings: "Contact Settings", title: "Title", date: "Date",
  status: "Status", actions: "Actions", live: "Live", draft: "Draft",
  loading: "Loading…", noArticlesYet: "No articles yet. Click New Article.",
  editArticle: "Edit Article", createArticle: "New Article",
  titleRequired: "Title *", summary: "Summary", categoryRequired: "Category *",
  tags: "Tags (comma separated)", body: "Body * (Telugu supported)",
  bodyFont: "Telugu Font", coverImage: "Cover Image",
  additionalImages: "Additional Images (Photo Gallery)",
  pasteUrlOrUpload: "Paste URL or upload…",
  upload: "Upload", uploading: "Uploading…",
  addImage: "Add Image", remove: "Remove",
  youtubeEmbedUrl: "YouTube Embed URL",
  featured: "Featured (Hero)", flashNewsToggle: "Show in Breaking News",
  published: "Published", update: "Update", publish: "Publish",
  cancel: "Cancel", confirmDelete: "Delete this article?",
  addCategory: "Add Category", slug: "Slug (URL)",
  nameEnglish: "Name (English)", nameTelugu: "Name (Telugu)",
  order: "Order", save: "Save", edit: "Edit", delete: "Delete",
  liveTvSettings: "Live TV Settings", streamUrl: "Stream URL", streamType: "Stream Type",
  streamTypeYoutube: "YouTube", streamTypeHls: "HLS (.m3u8)", streamTypeMp4: "MP4",
  channelTitleEn: "Channel Name (English)", channelTitleTe: "Channel Name (Telugu)",
  saveSettings: "Save Settings",
  liveTvHelp: "YouTube: use /embed/VIDEO_ID URL. HLS: .m3u8 link. RTMP does not work in browsers.",
  latestNewsFeed: "Latest News Feed",
  channelId: "YouTube Channel ID", channelIdHelp: "Copy channel ID from your channel URL (starts with UC...)",
  autoImport: "Auto Import", defaultCategory: "Default Category",
  syncNow: "Sync Now", syncing: "Syncing...",
  addAd: "Add Ad", adName: "Ad Name", placement: "Placement",
  linkUrl: "Click Link URL", imageUrl: "Image URL", videoUrl: "Video URL", active: "Active",
  privacyPolicy: "Privacy Policy", termsConditions: "Terms & Conditions",
  phone: "Phone", address: "Address",
  footerTagline: "Trusted news. Breaking stories, deep analysis, essential coverage.",
  sections: "Sections", more: "More",
  newsletter: "Newsletter", newsletterDesc: "Daily top stories to your inbox.",
  yourEmail: "Your Email", subscribe: "Subscribe",
  allRightsReserved: "© 2026 News 9 Today. All rights reserved.",
  editorialTrusted: "Editorial · Independent · Trusted",
  contactUs: "Contact Us",
  language: "Language", fontSize: "Font Size", channels: "Channels",
};

export const hi = {
  home: "होम", liveTv: "लाइव टीवी", admin: "एडमिन",
  search: "खोजें", searchPlaceholder: "समाचार खोजें...",
  flashNews: "ब्रेकिंग न्यूज", breakingNews: "ब्रेकिंग न्यूज",
  siteTagline: "विश्वसनीय समाचार · 24×7", privacy: "गोपनीयता नीति", terms: "नियम",
  latestNews: "ताज़ा समाचार", trendingNow: "अभी ट्रेंडिंग",
  onAir: "प्रसारण पर", viewAll: "सभी देखें →", abnVideos: "न्यूज 9 वीडियो",
  weather: "मौसम", stockMarket: "शेयर बाज़ार",
  relatedStories: "संबंधित खबरें", share: "शेयर",
  articleNotFound: "लेख नहीं मिला", backToHome: "← होम पर वापस",
  views: "व्यूज़",
  category: "श्रेणी", stories: "समाचार",
  noStoriesYet: "इस श्रेणी में अभी कोई समाचार नहीं.", checkBackSoon: "जल्द ही फिर देखें.",
  previous: "पिछला", next: "अगला", page: "पेज", of: "में से",
  searchResults: "खोज परिणाम", noResults: "कोई परिणाम नहीं", resultsFor: "के लिए परिणाम",
  adminPortal: "एडमिन पोर्टल", signInToPublish: "समाचार प्रकाशित करने के लिए साइन इन करें",
  email: "ईमेल", password: "पासवर्ड", signIn: "साइन इन", signingIn: "साइन इन हो रहा है…",
  newsroomDashboard: "न्यूजरूम डैशबोर्ड", newArticle: "नया लेख",
  logout: "लॉगआउट", signedInAs: "साइन इन किया",
  articles: "लेख", categories: "श्रेणियाँ", siteSettings: "साइट सेटिंग्स",
  ads: "विज्ञापन", pages: "पेज", youtubeSync: "यूट्यूब सिंक",
  contactSettings: "संपर्क सेटिंग्स", title: "शीर्षक", date: "तारीख",
  status: "स्थिति", actions: "कार्यवाही", live: "लाइव", draft: "ड्राफ्ट",
  loading: "लोड हो रहा है…", noArticlesYet: "अभी कोई लेख नहीं. नया लेख क्लिक करें.",
  editArticle: "लेख संपादित करें", createArticle: "नया लेख",
  titleRequired: "शीर्षक *", summary: "सारांश", categoryRequired: "श्रेणी *",
  tags: "टैग (कॉमा से अलग)", body: "लेख विवरण *",
  bodyFont: "फ़ॉन्ट", coverImage: "कवर छवि",
  additionalImages: "अतिरिक्त छवियाँ", pasteUrlOrUpload: "URL पेस्ट करें या अपलोड करें…",
  upload: "अपलोड", uploading: "अपलोड हो रहा है…",
  addImage: "छवि जोड़ें", remove: "हटाएं",
  youtubeEmbedUrl: "यूट्यूब एम्बेड URL",
  featured: "फीचर्ड (हीरो)", flashNewsToggle: "ब्रेकिंग न्यूज में दिखाएं",
  published: "प्रकाशित", update: "अपडेट", publish: "प्रकाशित करें",
  cancel: "रद्द करें", confirmDelete: "इस लेख को हटाएं?",
  addCategory: "श्रेणी जोड़ें", slug: "स्लग (URL)",
  nameEnglish: "नाम (अंग्रेज़ी)", nameTelugu: "नाम (तेलुगू)",
  order: "क्रम", save: "सहेजें", edit: "संपादित करें", delete: "हटाएं",
  liveTvSettings: "लाइव टीवी सेटिंग्स", streamUrl: "स्ट्रीम URL", streamType: "स्ट्रीम प्रकार",
  streamTypeYoutube: "यूट्यूब", streamTypeHls: "HLS (.m3u8)", streamTypeMp4: "MP4",
  channelTitleEn: "चैनल नाम (अंग्रेज़ी)", channelTitleTe: "चैनल नाम (तेलुगू)",
  saveSettings: "सेटिंग्स सहेजें",
  liveTvHelp: "यूट्यूब: /embed/VIDEO_ID URL. HLS: .m3u8 लिंक. RTMP सीधे ब्राउज़र में काम नहीं करता.",
  latestNewsFeed: "ताज़ा समाचार फ़ीड",
  channelId: "यूट्यूब चैनल ID", channelIdHelp: "अपने चैनल URL से channel ID कॉपी करें (UC... से शुरू)",
  autoImport: "ऑटो इम्पोर्ट", defaultCategory: "डिफ़ॉल्ट श्रेणी",
  syncNow: "अभी सिंक करें", syncing: "सिंक हो रहा है...",
  addAd: "विज्ञापन जोड़ें", adName: "विज्ञापन नाम", placement: "स्थान",
  linkUrl: "क्लिक लिंक URL", imageUrl: "छवि URL", videoUrl: "वीडियो URL", active: "सक्रिय",
  privacyPolicy: "गोपनीयता नीति", termsConditions: "नियम और शर्तें",
  phone: "फोन", address: "पता",
  footerTagline: "विश्वसनीय समाचार. ब्रेकिंग न्यूज, गहन विश्लेषण, महत्वपूर्ण कवरेज.",
  sections: "श्रेणियाँ", more: "और",
  newsletter: "न्यूज़लेटर", newsletterDesc: "दैनिक टॉप समाचार आपके इनबॉक्स में.",
  yourEmail: "आपका ईमेल", subscribe: "सब्सक्राइब",
  allRightsReserved: "© 2026 न्यूज 9 टुडे. सर्वाधिकार सुरक्षित.",
  editorialTrusted: "संपादकीय · स्वतंत्र · विश्वसनीय",
  contactUs: "संपर्क करें",
  language: "भाषा", fontSize: "फ़ॉन्ट आकार", channels: "चैनल",
};

export const LANGUAGES = [
  { code: "te", label: "తెలుగు", native: "Telugu" },
  { code: "en", label: "English", native: "English" },
  { code: "hi", label: "हिंदी", native: "Hindi" },
];

export const dictionaries = { te, en, hi };
